import type { ViewState } from 'react-map-gl/mapbox';

/**
 * Returns the default map view state centered near the equator/prime meridian
 * with a wide zoom level. When {@link withElevationChart} is `true`, extra
 * bottom padding is applied to leave room for an elevation chart overlay.
 *
 * @param withElevationChart - When `true`, increases the bottom padding to `330` to accommodate the elevation chart overlay (220px height + 25px margin + breathing room). Defaults to `false`.
 * @returns A {@link ViewState} with default center, zoom, and padding values.
 */
export function getDefaultViewState({
  withElevationChart,
}: { withElevationChart?: boolean } = {}): ViewState {
  return {
    longitude: 1.0,
    latitude: 1.0,
    zoom: 0.44,
    pitch: 0,
    bearing: 0,
    padding: {
      top: 100,
      bottom: withElevationChart ? 330 : 100,
      left: 100,
      right: 100,
    },
  };
}
